module.exports = __webpack_public_path__ + "static/img/qrcode.c18c22e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qrcode.png
// module id = cgBV
// module chunks = 0